/**
 * Utility function to replace Korean address and phone number in text content
 * This is a temporary fix to replace:
 * - Old Korean address with the new one
 * - Old Italian phone number with the new one
 */

const OLD_KOREAN_ADDRESS = "608, Gieopdosi-ro 200, Jijeong-myeon, Wonju-si, Gangwon-do, Corée";
const NEW_KOREAN_ADDRESS = "161, Usangongdan-gil, Wonju-si, Gangwon-do, Republic of Korea";

// Phone number replacement
const OLD_PHONE_NUMBER = "+39 340 108 5210";
const NEW_PHONE_NUMBER = "+39 388 483 1256";

// Additional variations that might appear in the content
const ADDRESS_VARIATIONS = [
  "608, Gieopdosi-ro 200, Jijeong-myeon, Wonju-si, Gangwon-do, Republic of Korea",
  "608, Gieopdosi-ro 200, Jijeong-myeo, Wonju-si, Gangwon-do, Republic of Korea",
  "608, Gieopdosi-ro 200, Jijeong-myeon, Wonju-si, Gangwon-do",
  "608, Gieopdosi-ro 200, Jijeong-myeo, Wonju-si, Gangwon-do",
  // Italian and Spanish variations with "Corea"
  "608, Gieopdosi-ro 200, Jijeong-myeon, Wonju-si, Gangwon-do, Corea",
  "608, Gieopdosi-ro 200, Jijeong-myeo, Wonju-si, Gangwon-do, Corea",
];

/**
 * Replace Korean address and phone number in any text content
 * @param text - The text content to process
 * @returns The text with Korean address and phone number replaced
 */
export const replaceKoreanAddress = (text: string): string => {
  if (!text || typeof text !== 'string') {
    return text;
  }

  let result = text;

  // Replace the main address pattern
  result = result.replace(OLD_KOREAN_ADDRESS, NEW_KOREAN_ADDRESS);

  // Replace any variations
  ADDRESS_VARIATIONS.forEach(variation => {
    result = result.replace(variation, NEW_KOREAN_ADDRESS);
  });

  // Fix duplicate "Korea" issue - remove trailing ", Korea" after "Republic of Korea"
  result = result.replace(/Republic of Korea,\s*Korea/g, 'Republic of Korea');
  
  // Fix duplicate "Corea" issue - remove trailing ", Corea" after "Republic of Korea"
  result = result.replace(/Republic of Korea,\s*Corea/g, 'Republic of Korea');

  // Replace phone number
  result = result.replace(OLD_PHONE_NUMBER, NEW_PHONE_NUMBER);

  return result;
};

/**
 * Deep replace Korean address and phone number in any object/array structure
 * @param obj - The object to process
 * @returns The object with Korean address and phone number replaced in all string values
 */
export const replaceKoreanAddressInObject = (obj: any): any => {
  if (typeof obj === 'string') {
    return replaceKoreanAddress(obj);
  }

  if (Array.isArray(obj)) {
    return obj.map(item => replaceKoreanAddressInObject(item));
  }

  if (obj && typeof obj === 'object') {
    const result = { ...obj };
    Object.keys(result).forEach(key => {
      result[key] = replaceKoreanAddressInObject(result[key]);
    });
    return result;
  }

  return obj;
};